import { OwnerLogo } from "../OwnerLogo/web";
import "./styles.less";
import { useContext } from "react";
import { Owner } from "shared-components";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getInmoLink } from "src/utils/Functions";

export const OwnerInfo = ({ owner = null }: { owner?: Owner }) => {
	if (owner == null) return null;

	const { country_code } = useContext(ConfigStateContext);
	const inmoLink = country_code === "CO" && owner.particular == false ? getInmoLink(owner.id, owner.name) : owner.inmoLink;

	return (
		<div className="owner-info">
			<OwnerLogo
				inmoLink={inmoLink}
				inmoPropsLink={owner.inmoLinkProps}
				logo={owner.logo}
				type="full"
				name={owner.name}
				inmoFull={owner.inmofull}
			/>
		</div>
	);
};
